/**
 * 格式化错误调用栈
 */
import { DefTypes } from '../constants';
import * as ErrorStackParser from '../lib/errorStack';
import { IPubStackFrame } from '../types';
import { convertAnyErrorToString, fixReportError, getLocation } from './func';

export const UNKNOWN_FUNCTION = '?';

function parseStack(error: Error, depth: number): any {
  error = fixReportError(error);

  if (typeof error.stack === DefTypes.UNDEFINED || !error.stack) {
    return {
      parsedStack: {
        name: 'Error',
        message: convertAnyErrorToString(error),
        url: getLocation(),
        stack: [],
        originStack: '',
      },
      labels: {
        pubAppName: null,
        resourceId: null,
      },
    };
  }

  const stackFrames: IPubStackFrame[] = ErrorStackParser.parse(error);
  const stack = [];

  let g_pubAppName: string | undefined;
  let g_resourceId: string | undefined;

  for (const [index, { stackFrame, pubAppName, resourceId }] of stackFrames.entries()) {
    if (!g_pubAppName) {
      g_pubAppName = pubAppName;
    }
    if (!g_resourceId) {
      g_resourceId = resourceId;
    }
    if (index < depth) {
      stack.push({
        url: stackFrame.fileName,
        func: stackFrame.functionName || UNKNOWN_FUNCTION,
        args: stackFrame.args || [],
        line: stackFrame.lineNumber,
        column: stackFrame.columnNumber,
      });
    }
  }

  return {
    parsedStack: {
      name: error.name,
      message: error.message,
      url: getLocation(),
      stack,
      originStack: error.stack,
    },
    labels: {
      pubAppName: g_pubAppName,
      resourceId: g_resourceId,
    },
  };
}

export default {
  parseStack,
};
